import React, { useEffect } from 'react';
import { Text } from '@ln/common-ui-text';
import Menu from '../Routes/Home';
import { CardBoxHome } from '../Components/Common/Modules/CardBoxHome';
import useGetUsuarioLogeado from '../Hooks/useGetUsuarioLogeado';

const Home = () => {
    const { usuarioLogeado } = useGetUsuarioLogeado()
    
    return (
        <div className="gap-16 gap-24_md mt-24 mb-24">
            <div className="w-100 flex flex-column">
                <Text className="mb-16 prumo prumo-medium text-32 pb-4 text-center">Mi cuenta</Text>
                {/* <Text className="mb-16 prumo prumo-medium text-18 text-center">Descripción acá de dos líneas</Text> */}
            </div>
            <div className="grid grid-cols-8 grid-cols-12_md grid-cols-16_xl grid-row-gap home-grid">
                {Menu.map(({ GroupName, Icon, Childrens }) => {
                    return <CardBoxHome key={GroupName} icon={Icon} title={GroupName} links={Childrens} />;
                })}
            </div>
        </div>
    );
};

export default Home;
